const data = [
  { flair: 'University', 'Number of posts': 6874 },
  { flair: 'CS/EECS', 'Number of posts': 5680 },
  { flair: 'Other', 'Number of posts': 5093 },
  { flair: 'Local', 'Number of posts': 1326 },
  { flair: 'Politics', 'Number of posts': 238 },
];

export default data;
